import React, { useEffect, useState } from "react"
import { Col, Row, Input, Select, DatePicker } from "antd"
import moment from 'moment'
import InventoryFilter from "./InventoryFilter"
import InventoryTable from "./InventoryTable"
import './inventory.css'
import { IBox, IDates } from "../interface/interface"
import { RangeValue } from 'rc-picker/lib/interface'
import 'moment/locale/fr';
import locale from 'antd/es/date-picker/locale/fr_FR';
import Fuse from 'fuse.js'

const defaultBox: IBox = {
  ON_GOING: true,
  PENDING: true,
  COMPLETE: true,
  TO_DO: false,
}

const dateFormat = 'DD/MM/YYYY';

const defaultSlider: [number, number] = [0, 10000]

function Inventory() {
  const [checkedBox, setCheckedBox] = useState<IBox>(defaultBox)
  const [dates, setDates] = useState<IDates>({ start: undefined, end: undefined })
  const [slider, setSlider] = useState<[number, number]>(defaultSlider)
  const [dateRange, setDateRange] = useState<{ start: Date | undefined, end: Date | undefined }>({ start: undefined, end: undefined })
  const [data, setData] = useState<any>(undefined)
  const [fuse, setFuse] = useState<any>(undefined)
  const [results, setResults] = useState<any[]>([])
  const [empty, setEmpty] = useState<boolean>(true)
  const { Option } = Select;

  useEffect(() => {
    setFuse(new Fuse(data, { keys: ["bpNumber"], distance: 10, threshold: 0.2 }))
  }, [data])

  const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const res = fuse.search(event.target.value)
    let list: any[] = []
    list.push(res.map((elem: { item: any }) => elem.item))
    setResults(list[0])
    if (event.target.value.length === 0)
      setEmpty(true)
    else setEmpty(false)
  }

  const handleSelect = (e) => {
    setFuse(new Fuse(data, { keys: [e], distance: 1, threshold: 0.0 }))
  }

  const handleDate = (e: RangeValue<moment.Moment>) => {
    const start: Date | undefined = e?.[0]?.toDate()
    const end: Date | undefined = e?.[1]?.toDate()
    setDateRange({ start: start, end: end })
  }

  const Dates = () => (
    <DatePicker.RangePicker
      style={{ width: '100%' }}
      size='large'
      defaultValue={[moment(), moment()]}
      value={[moment(dateRange.start), moment(dateRange.end)]}
      onChange={(event) => handleDate(event)}
      locale={locale}
      format={dateFormat}
      placeholder={['Du', 'Au']} />
  )

  return (
    <>
      <Row style={{ width: '100%', paddingTop: "1rem", backgroundColor: "#f6f1eb" }}>
        <Col style={{ paddingBottom: "1rem" }} xs={24} md={6} pull={0} span={8} className="inventory-title" id="inventory-title">
          Tous BP
        </Col>
        <Col xs={24} md={5} style={{ marginLeft: "2.2%" }}>
          <Dates />
        </Col>
        <Col xs={4} offset={2}>
          <Select style={{ width: '90%' }} onChange={(event) => handleSelect(event)} defaultValue={"bpNumber"} className='edit-select' size="large">
            <Option value="bpNumber">N°BP</Option>
            <Option value="sku">SKU</Option>
          </Select>
        </Col>
        <Col xs={5}>
          <Input.Search
            onChange={handleInput}
            placeholder="Rechercher un SKU, BP..."
            allowClear
            size="large"
          />
        </Col>
      </Row>
      <Row style={{ backgroundColor: "#f6f1eb" }} className="row-margin" gutter={0}>
        <Col style={{ backgroundColor: "#f6f1eb" }} span={6} >
          <InventoryFilter
            setCheckedBox={setCheckedBox} checkedBox={checkedBox}
            setDates={setDates} dates={dates}
            setSlider={setSlider} slider={slider}
            setDateRange={setDateRange} dateRange={dateRange}
          />
        </Col>
        <Col style={{ backgroundColor: "#f6f1eb" }} span={18} >
          <InventoryTable
            checkedBox={checkedBox}
            slider={slider}
            dateRange={dateRange}
            data={results && !empty ? results : data}
            setData={setData}
          />
        </Col>
      </Row>
    </>
  )
}

export default Inventory